var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15 6.5C7.71239 6.5 7.29271 6.67384 6.98327 6.98327C6.67384 7.29271 6.5 7.71239 6.5 8.15V9.8C6.5 10.1038 6.74624 10.35 7.05 10.35C7.35376 10.35 7.6 10.1038 7.6 9.8V8.15C7.6 8.00413 7.65795 7.86424 7.76109 7.76109C7.86424 7.65795 8.00413 7.6 8.15 7.6H9.8C10.1038 7.6 10.35 7.35376 10.35 7.05C10.35 6.74624 10.1038 6.5 9.8 6.5H8.15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 6.5C13.8962 6.5 13.65 6.74624 13.65 7.05C13.65 7.35376 13.8962 7.6 14.2 7.6H15.85C15.9959 7.6 16.1358 7.65795 16.2389 7.76109C16.3421 7.86424 16.4 8.00413 16.4 8.15V9.8C16.4 10.1038 16.6462 10.35 16.95 10.35C17.2538 10.35 17.5 10.1038 17.5 9.8V8.15C17.5 7.71239 17.3262 7.29271 17.0167 6.98327C16.7073 6.67384 16.2876 6.5 15.85 6.5H14.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 14.2C7.6 13.8962 7.35376 13.65 7.05 13.65C6.74624 13.65 6.5 13.8962 6.5 14.2V15.85C6.5 16.2876 6.67384 16.7073 6.98327 17.0167C7.29271 17.3262 7.71239 17.5 8.15 17.5H9.8C10.1038 17.5 10.35 17.2538 10.35 16.95C10.35 16.6462 10.1038 16.4 9.8 16.4H8.15C8.00413 16.4 7.86424 16.3421 7.76109 16.2389C7.65795 16.1358 7.6 15.9959 7.6 15.85V14.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.2C17.5 13.8962 17.2538 13.65 16.95 13.65C16.6462 13.65 16.4 13.8962 16.4 14.2V15.85C16.4 15.9959 16.3421 16.1358 16.2389 16.2389C16.1358 16.3421 15.9959 16.4 15.85 16.4H14.2C13.8962 16.4 13.65 16.6462 13.65 16.95C13.65 17.2538 13.8962 17.5 14.2 17.5H15.85C16.2876 17.5 16.7073 17.3262 17.0167 17.0167C17.3262 16.7073 17.5 16.2876 17.5 15.85V14.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.acc4f4d9f40d307e355a66677911aebc.svg";
export { ForwardRef as ReactComponent };